import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { withStyles } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import List from '@material-ui/core/List';

import IconHome from 'components/icons/IconHome';
import IconWorkFlow from 'components/icons/IconWorkFlow';
import IconCharts from 'components/icons/IconCharts';
import IconCalendarStart from 'components/icons/IconCalendarStart';
import IconBoxes from 'components/icons/IconBoxes';
import IconGraphs from 'components/icons/IconGraphs';
import Button from 'components/common/Button';
import IconMenu from 'components/icons/IconMenu';
import IconTransmit from 'components/icons/IconTransmit';

import DefaultNavigationItem from './DefaultNavigationItem';

const styles = theme => ({
  drawerPaper: {
    top: 64,
    width: 132,
    border: 'none',
    background: theme.palette.secondary['800'],
    overflow: 'visible',
    transition: theme.transitions.create(['width'], {
      duration: theme.transitions.duration.short,
    }),
    [theme.breakpoints.down('sm')]: {
      width: 48,
    },
  },
  drawerPaperCollapsed: {
    width: 48,
    [theme.breakpoints.down('sm')]: {
      width: 0,
    },
  },
  list: {
    padding: '75px 0 0 0',
    [theme.breakpoints.down('sm')]: {
      padding: 0,
    },
  },
  iconHome: {
    width: '21px',
    height: '18px',
    margin: '-2px 11px 0 0',
    color: 'inherit',
  },
  iconWorkFlow: {
    width: '20px',
    height: '20px',
    margin: '0 12px 0 0',
    color: 'inherit',
  },
  iconCharts: {
    width: '20px',
    height: '23px',
    margin: '0 12px 0 0',
    color: 'inherit',
  },
  iconCalendarStart: {
    width: 18,
    height: 20,
    margin: '0 12px 0 0',
    color: 'inherit',
  },
  iconBoxes: {
    width: '20px',
    height: '18px',
    margin: '0 12px 0 0',
    color: 'inherit',
  },
  iconGraphs: {
    width: '20px',
    height: '16px',
    margin: '0 12px 0 0',
    color: 'inherit',
  },
  iconTransmit: {
    width: 18,
    height: 18,
    margin: '0 12px 0 0',
    color: 'inherit',
  },
  button: {
    position: 'absolute',
    zIndex: 10,
    top: 19,
    width: 30,
    height: 30,
    minHeight: 30,
    right: -15,
    [theme.breakpoints.down('sm')]: {
      width: 48,
      height: 48,
      top: -57,
      right: 'auto',
      left: 0,
      backgroundColor: 'transparent',
      boxShadow: 'none',
    },
  },
  iconMenu: {
    width: 18,
    height: 18,
    [theme.breakpoints.down('sm')]: {
      width: 24,
      height: 24,
    },
  },
});

const DefaultNavigation = ({ expanded, onExpandCollapseButtonClick, classes }) => (
  <Drawer
    open
    variant="permanent"
    classes={{
      paper: classNames(classes.drawerPaper, {
        [classes.drawerPaperCollapsed]: !expanded,
      }),
    }}
  >
    <Button
      variant="fab"
      className={classes.button}
      onClick={onExpandCollapseButtonClick}
    >
      <IconMenu
        className={classes.iconMenu}
      />
    </Button>
    <List className={classes.list}>
      <DefaultNavigationItem
        title="Dashboard"
        href="/"
        icon={(
          <IconHome className={classes.iconHome} />
        )}
        expanded={expanded}
      />
      <DefaultNavigationItem
        title="Work Flow"
        href="/workflow"
        icon={(
          <IconWorkFlow className={classes.iconWorkFlow} />
        )}
        expanded={expanded}
      />
      <DefaultNavigationItem
        title="Schedule"
        href="/workflow/delivery/schedule/day"
        icon={(
          <IconCalendarStart className={classes.iconCalendarStart} />
        )}
        expanded={expanded}
      />
      <DefaultNavigationItem
        title="Charts"
        href="/charts"
        icon={(
          <IconCharts className={classes.iconCharts} />
        )}
        expanded={expanded}
      />
      <DefaultNavigationItem
        title="Inventory"
        href="/inventory"
        icon={(
          <IconBoxes className={classes.iconBoxes} />
        )}
        expanded={expanded}
      />
      <DefaultNavigationItem
        title="Reports"
        href="/reports"
        icon={(
          <IconGraphs className={classes.iconGraphs} />
        )}
        expanded={expanded}
      />
      <DefaultNavigationItem
        title="Claims"
        href="/claims"
        icon={(
          <IconTransmit className={classes.iconTransmit} />
        )}
        expanded={expanded}
      />
    </List>
  </Drawer>
);

DefaultNavigation.propTypes = {
  expanded: PropTypes.bool,
  onExpandCollapseButtonClick: PropTypes.func.isRequired,
  classes: PropTypes.shape({
    drawerPaper: PropTypes.string.isRequired,
    drawerPaperCollapsed: PropTypes.string.isRequired,
    list: PropTypes.string.isRequired,
    iconHome: PropTypes.string.isRequired,
    iconWorkFlow: PropTypes.string.isRequired,
    iconCharts: PropTypes.string.isRequired,
    iconCalendarStart: PropTypes.string.isRequired,
    iconBoxes: PropTypes.string.isRequired,
    iconGraphs: PropTypes.string.isRequired,
    iconTransmit: PropTypes.string.isRequired,
    button: PropTypes.string.isRequired,
    iconMenu: PropTypes.string.isRequired,
  }).isRequired,
};

DefaultNavigation.defaultProps = {
  expanded: true,
};

export default withStyles(styles)(DefaultNavigation);



// WEBPACK FOOTER //
// ./src/components/common/Layout/DefaultNavigation/DefaultNavigation.js